export default "__VITE_ASSET__DtVz3Sp4__"